module.exports = __webpack_public_path__ + "img/open_white.1cf76551.svg";